import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface PageWithHeaderState {
	isUploadingAvatar: boolean;
}

@Injectable()
export class PageWithHeaderStore extends Store<PageWithHeaderState> {
	constructor() {
		super(
			{ isUploadingAvatar: false },
			{ name: `ui-page-with-header-${guid()}` }
		);
	}
}
